import {useState } from "react";
import useTable from '../../../hooks/table';
import TableFooter from '../../../hooks/table/footer';

const TotalizaResultados = ({ resultados, NombreMes, NombreArea, NombreServ, NombreFact }) => {
   const [page, setPage] = useState(1);
   const { slice, range } = useTable(resultados, page, 10);  

  return (
      <div className='flex flex-col w-full mb-4 items-center justify-center'>
        <div className='flex flex-col w-[100%] md:w-[80%] rounded-lg bg-empresa-50 border border-empresa-500 py-4'>
          <div className='flex flex-row w-full'>
             <span className='text-right w-[7rem] text-gray-700 font-semibold'>Area:</span>
             <span className='text-left w-[12rem] ml-2'> {NombreArea}</span>
             <span className='text-right w-[7rem] text-gray-700 font-semibold'>Mes:</span>
             <span className='text-left w-[12rem] ml-2'>{NombreMes}</span>
          </div>   
          <div className='flex flex-row w-full'>
            <span className='text-right w-[7rem] text-gray-700 font-semibold'>Servicio:</span>
            <span className='text-left w-[12rem] ml-2'> {NombreServ !=='' ? NombreServ :'Todos los Servicios' }</span>
            <span className='text-right w-[7rem] text-gray-700 font-semibold'>Facturador:</span>
            <span className='text-left w-[12rem] ml-2'> {NombreFact !=='' ? NombreFact :'Todos' }</span>
          </div>
        </div>

      <div className="mt-2 rounded-lg border border-stone-200 w-[80%] overflow-x-auto">
       <table className="w-full table-auto">
          <thead className="border-b border-stone-200 text-sm font-medium">
            <tr>
              <th className="px-2.5 py-2 text-start font-medium">Día</th>
              <th className="px-2.5 py-2 text-start font-medium">Atendidos</th>
              <th className="px-2.5 py-2 text-start font-medium">Promedio(seg)</th>
           </tr>
          </thead>
          <tbody className="group text-sm text-stone-800 ">
            {slice.map((item) => 
            {
               let Promedio =0
               if ((item.Tiempo >0) && (item.Atendido >0))
                 Promedio = (item.Tiempo /item.Atendido) 
               return(
                 <tr key={`${item.Dia}`} className="border-b border-stone-200 last:border-0">
                      <td>{item.Dia}</td>
                      <td>{item.Atendido}</td>
                      <td>{Promedio.toFixed(2)}</td>
                 </tr>)
            })}
         </tbody>
       </table>
    </div> 
    <TableFooter range={range} slice={slice} setPage={setPage} page={page} /> 
    </div>  
    );
};

export default TotalizaResultados;
